﻿<script>
    import {List, ListGroup, ListItem} from "framework7-svelte";
    import { _ } from "svelte-i18n";
    
    import FloatingButton from "../FloatingButton.svelte";

    export let modeNdwActive = false;
    export let modeNdwInactive = false;
    export let showNdwSpeed = false;
    export let showNdwFlow = false;
    
</script>

<FloatingButton
        label="{$_('pages.project.NDW_MEASUREMENTS_LABEL')}"
        active={modeNdwActive || modeNdwInactive}
        activeIcon="check"
        inactiveIcon=""
        popoverWidth="336px">

    <List ul={false}>
        <ListGroup>
            <ListItem title="{$_('shared.DISPLAY')}" groupTitle />

            <ListItem
                    checkbox
                    checkboxIcon="end"
                    title="{$_('pages.project.NDW_ACTIVE_INTENSITY')}"
                    bind:checked={modeNdwActive} />

            <ListItem
                    checkbox    
                    checkboxIcon="end"
                    title="{$_('pages.project.NDW_INACTIVE_INTENSITY')}"
                    bind:checked={modeNdwInactive} />

        </ListGroup>

        <hr class="divider--direction-horizontal"/>

        <ListGroup>
            <ListItem title="{$_('shared.SHOW_VALUES')}" groupTitle />

            <ListItem
                    checkbox
                    checkboxIcon="end"
                    title="{$_('pages.project.NDW_SPEED')}"
                    bind:checked={showNdwSpeed} />

            <ListItem
                    checkbox
                    checkboxIcon="end"
                    title="{$_('pages.project.NDW_FLOW')}"
                    bind:checked={showNdwFlow} />

        </ListGroup>
    </List>

</FloatingButton>